var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargerCable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "255 345 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "       M340.5,367.5c0,1.657-1.343,3-3,3h-64c-1.657,0-3-1.343-3-3v-4c0-1.657,1.343-3,3-3h64c1.657,0,3,1.343,3,3V367.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "       M335.5,387.5c0,1.657-1.343,3-3,3h-54c-1.657,0-3-1.343-3-3v-4c0-1.657,1.343-3,3-3h54c1.657,0,3,1.343,3,3V387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "       M330.5,407.5c0,1.657-1.343,3-3,3h-44c-1.657,0-3-1.343-3-3v-4c0-1.657,1.343-3,3-3h44c1.657,0,3,1.343,3,3V407.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "       M325.5,427.5c0,1.657-1.343,3-3,3h-34c-1.657,0-3-1.343-3-3v-4c0-1.657,1.343-3,3-3h34c1.657,0,3,1.343,3,3V427.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerCable);
export default __webpack_public_path__ + "static/media/charger_cable.0487bf9af4409fe81bb18e540d5323c1.svg";
export { ForwardRef as ReactComponent };